<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title"></h4>
                        <p class="category"></p>
                    </div>

                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-12">
                                <label>Client: John Smith</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8">
                                <label>Assessment: Sports / 360 / 2.0</label>
                            </div>
                            <div class="col-md-4 text-right">
                                <i [routerLink]="['/app','co_a_report_360']" class="material-icons">description</i>
                                <i class="material-icons">add</i>
                                <i class="material-icons">email</i>
                            </div>
                        </div>
                        <br />
                        <div class="table-responsive">
                            <table id="table" class="table table-striped " cellspacing="0" width="100%">
                                <thead>
                                    <tr>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>Relationship</th>
                                        <th>Email</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!--*ngFor="let row of data; let i = index"-->
                                    <tr>
                                        <td>John</td>
                                        <td>Doe</td>
                                        <td>Friend</td>
                                        <td>john.doe@raters.com</td>
                                        <td>Pending</td>
                                        <td>
                                            <i  class="material-icons">email</i>
                                            <i  class="material-icons">close</i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>John</td>
                                        <td>Smith</td>
                                        <td>Friend</td>
                                        <td>john.Smith@raters.com</td>
                                        <td>Pending</td>
                                        <td>
                                            <i class="material-icons">email</i>
                                            <i class="material-icons">close</i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Jane</td>
                                        <td>Doe</td>
                                        <td>Relative</td>
                                        <td>jane.doe@raters.com</td>
                                        <td>Completed</td>
                                        <td>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-purchase-assessment-modal #purchaseAssessment></app-purchase-assessment-modal>
<app-assign-assesments-modal #assignAssessment></app-assign-assesments-modal>
